module.exports = __webpack_public_path__ + "static/cooklebanner-410c65bc712655a9f6e0c2d72568b8c8.png";